import React, { Component } from 'react';
import { Icon, Layout, Menu } from 'antd';
import { Link } from 'react-router';

import { getMenu } from '@store/modules/menu';
import { connect } from 'react-redux';
import Logo from '../../assets/img/logo.png';

const { Header, Content } = Layout;
const { SubMenu } = Menu;

class Siderbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: '',
      openKeys: [''],
    };
  }

  componentDidMount() {
    const { pathname } = this.props.router.location;
    const arr = pathname.split('/');
    this.setState({
      current: arr[3] || arr[2],
      openKeys: [arr[1]],
    });
    const { dispatch } = this.props;
    dispatch(getMenu());
  }

  handleClick = e => {
    this.setState({
      current: e.key,
    });
  };

  onOpenChange = openKeys => {
    const { state } = this;
    const latestOpenKey = openKeys.find(key => !(state.openKeys.indexOf(key) > -1));
    const latestCloseKey = state.openKeys.find(key => !(openKeys.indexOf(key) > -1));

    let nextOpenKeys = [];
    if (latestOpenKey) {
      nextOpenKeys = this.getAncestorKeys(latestOpenKey).concat(latestOpenKey);
    }
    if (latestCloseKey) {
      nextOpenKeys = this.getAncestorKeys(latestCloseKey);
    }
    this.setState({
      openKeys: nextOpenKeys,
    });
  };

  getAncestorKeys = key => {
    const map = {
      auth: ['boss'],
      attendance: ['hr'],
      leave: ['hr'],
      overTime: ['hr'],
      fill: ['hr'],
      incuanalyze: ['incubator'],
    };
    return map[key] || [];
  };

  getMenuXml = data => {
    if (data && data.length > 0) {
      return data.map(item => {
        if (item.child && item.child.length > 0) {
          return (
            <SubMenu
              key={item.key}
              title={
                <span>
                  {item.icon ? <Icon type={item.icon} /> : ''}
                  <span>{item.name}</span>
                </span>
              }
            >
              {this.getMenuXml(item.child)}
            </SubMenu>
          );
        }
        return (
          <Menu.Item key={item.key}>
            <Link to={item.link}>
              {item.icon ? <Icon type={item.icon} /> : ''}
              <span>{item.name}</span>
            </Link>
          </Menu.Item>
        );
      });
    }
    return '';
  };

  render() {
    const { menu: menus } = this.props;
    return (
      <Layout
        style={{
          overflowY: 'scroll',
          height: '100%',
          background: '#001529',
          width: 220,
        }}
      >
        <Header style={{ minHeight: 100, margin: '0 auto', width: 200, padding: 0 }}>
          <img src={Logo} alt={Logo} style={{ width: '100%', paddingTop: 20 }} />
        </Header>
        <Content>
          <Menu
            mode="inline"
            theme="dark"
            openKeys={this.state.openKeys}
            selectedKeys={[this.state.current]}
            onOpenChange={this.onOpenChange}
            onClick={this.handleClick}
          >
            {this.getMenuXml(menus)}
          </Menu>
        </Content>
      </Layout>
    );
  }
}

export default connect(state => ({ menu: state.menu }))(Siderbar);



// WEBPACK FOOTER //
// ./src/components/comm/Siderbar.js